import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

const Pagination = ({ itemCount, pageSize, onPageChange, currentPage }) => {
    const pageCount = Math.ceil(itemCount / pageSize);

    if (pageCount === 1) return null;
    const pages = _.range(1, pageCount + 1);



    return (
        <div className="pagination-wrapper">
            <ul className="pg-pagination justify-content-center ">


                <li className={'page-item '} >
                    <a aria-label="Previous" onClick={() => { if (currentPage > 1) onPageChange(currentPage - 1) }} >
                        <i className="page-link fa fa-angle-double-right "></i>
                    </a>
                </li>



                {pages.map(page => (
                    <li
                        className={
                            page === currentPage
                                ? 'page-item active'
                                : 'page-item'
                        }
                        key={page}
                    >





                        <a
                            className="page-link"
                            onClick={() => onPageChange(page)}
                        >
                            {page}
                        </a>
                    </li>
                ))}


                <li className={'page-item'} >
                    <a aria-label="Previous" onClick={() => { if (currentPage < pageCount) onPageChange(currentPage + 1) }} >
                        <i className="page-link fa fa-angle-double-left"></i>
                    </a>
                </li>



            </ul>
        </div>
    );
};

Pagination.propTypes = {
    itemCount: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    currentPage: PropTypes.number.isRequired
};

export default Pagination;
